import React from 'react';
import { Grid, GridItem, GridItemProps } from '../../../Grid';

// Positioning for the input within the grid
const FieldGrid: React.FC<{
  alignLeft?: boolean;
  gridItemProps?: GridItemProps;
  children?: React.ReactNode;
}> = ({ alignLeft, gridItemProps, children }) => {
  const columnsByBreakpoint: GridItemProps = {
    desktop: gridItemProps?.desktop ?? 6,
    tabletLandscape: gridItemProps?.tabletLandscape ?? 6,
    tabletPortrait: gridItemProps?.tabletPortrait ?? 6,
    mobile: gridItemProps?.mobile ?? 4,
  };

  return (
    <Grid alignLeft={alignLeft}>
      <GridItem {...columnsByBreakpoint}>{children}</GridItem>
    </Grid>
  );
};

export default FieldGrid;
